/**
 * Interaction Manager
 * 
 * The interaction object is a "State Bridge" between user inputs and the simulation.
 * It provides:
 * 1. Smoothing (Lerp): Instead of snapping to the mouse, the figure follows a "ghost" target.
 * 2. Constraints: It bounds the movement within a safe area.
 * 3. State Tracking: Tracks dragging states for the ball and figure.
 */
window.InteractionHandler = class InteractionHandler {
  constructor() {
    this.isDraggingLeg = false;
    this.isDraggingBall = false;
    this.ikTarget = createVector();
    this.restPosition = createVector();
    this.legLerpSpeed = 0.3;
    this.dragLimits = { minX: -80, maxX: 80, minY: 10, maxY: 180 };
  }

  update(hipPos) {
    let goal;
    if (this.isDraggingLeg) {
      // Calculate constrained goal based on hip position
      let constrainedX = constrain(mouseX, hipPos.x + this.dragLimits.minX, hipPos.x + this.dragLimits.maxX);
      let constrainedY = constrain(mouseY, hipPos.y + this.dragLimits.minY, hipPos.y + this.dragLimits.maxY);
      goal = createVector(constrainedX, constrainedY);
    } else {
      goal = this.restPosition;
    }

    // Smoothly interpolate current target towards the goal
    this.ikTarget.lerp(goal, this.legLerpSpeed);
  }

  setRestPosition(x, y) {
    this.restPosition.set(x, y);
    // Initialize ikTarget to rest position on first setup
    if (this.ikTarget.mag() === 0) {
      this.ikTarget.set(this.restPosition);
    }
  }
}

// Global instance for convenience (as in original code)
window.interaction = null;
